export default "__VITE_ASSET__CApmz1Jj__"